import { get } from 'lodash';
import { useSelector } from 'react-redux';
import submittalsService from '@/services/api/submittalsService.js';
import { getCopyFromLastScope, getSchemaTitleAtPath } from '@/utils/eform-schema-paths';

const useCopyFromLast = ({ selectedDataElement, schema, payload, setPayload, addToastMessage }) => {
    const profile = useSelector(state => state.auth?.profile);

    return async (sectionPath) => {
        if (!selectedDataElement?.id) return;
        const senderOrgId = profile?.organizationId;
        if (!senderOrgId) {
            addToastMessage('Unable to identify your organization.', 'error');
            return;
        }
        const scope = getCopyFromLastScope(schema, sectionPath) || {};

        // Validate locally so the toast can name the missing fields using the
        // schema titles. BE has the same check as a safety net.
        const requiredPaths = [...(scope.filterPath || []), ...(scope.orderPath ? [scope.orderPath] : [])];
        const missing = requiredPaths
            .filter(p => !get(payload, p))
            .map(p => getSchemaTitleAtPath(schema, p) || p);
        if (missing.length > 0) {
            addToastMessage(`Please fill in ${missing.join(', ')} before copying from a previous submission.`, 'error');
            return;
        }

        const [err, data] = await submittalsService.getCopy({
            senderOrgId,
            dataElementId: selectedDataElement.id,
            payload,
            filterPath: scope.filterPath || [],
            orderPath: scope.orderPath || '',
            order: scope.order || 'DESC',
        });
        if (err || !data?.payload) {
            addToastMessage(err || 'No previous approved submission found.', 'error');
            return;
        }
        const sectionData = data.payload?.[sectionPath];
        if (!sectionData) {
            addToastMessage('No data available for this section.', 'error');
            return;
        }
        setPayload(prev => ({ ...prev, [sectionPath]: sectionData }));
        addToastMessage('Section copied from last approved submission.', 'success');
    };
};

export default useCopyFromLast;
